import { render, staticRenderFns } from "./DescriptionField.vue?vue&type=template&id=90e28496&scoped=true&"
import script from "./DescriptionField.vue?vue&type=script&lang=js&"
export * from "./DescriptionField.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionField.vue?vue&type=style&index=0&id=90e28496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e28496",
  null
  
)

export default component.exports